import React from "react";
import "../Styles/Services.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalculator,
  faDraftingCompass,
  faCar,
  faRoad,
  faHelmetSafety,
  faCogs,
  faHardHat,
  faIndustry,
  faBuildingColumns,
  faLaptopCode,
  faTree,
  faScaleBalanced,
  faGears,
  faBriefcaseMedical,
  faBolt,
  faTruck,
  faBridge,
  faRecycle,
} from "@fortawesome/free-solid-svg-icons";

function Services() {
  const industries = [
    { name: "Accounting | Tax", icon: faCalculator },
    { name: "Architecture", icon: faDraftingCompass },
    { name: "Automotive", icon: faCar },
    { name: "Civil Engineering", icon: faRoad },
    { name: "Construction", icon: faHelmetSafety },
    { name: "Engineering", icon: faCogs },
    { name: "Engineering | Construction", icon: faHardHat },
    { name: "Engineering | Light Industrial", icon: faIndustry },
    { name: "Government | Public Sector", icon: faBuildingColumns },
    { name: "Information Technology", icon: faLaptopCode },
    { name: "Landscaping", icon: faTree },
    { name: "Legal", icon: faScaleBalanced },
    { name: "Manufacturing", icon: faGears },
    { name: "Medical", icon: faBriefcaseMedical },
    { name: "Power | Energy", icon: faBolt },
    { name: "Transportation", icon: faTruck },
    { name: "Transportation Infrastructure", icon: faBridge },
    { name: "Waste Management", icon: faRecycle },
  ];

  return (
    <div id="industries" className="industries-section">
      <section className="services-top-section">
        <div className="services-header">
          <h2 className="services-title">
            <span>Industries</span>
          </h2>

          <p className="services-description">
            Workforce Nexus supports organizations across diverse sectors by aligning
            recruitment strategies with industry-specific hiring realities, operational
            needs, and workforce expectations. Our structured approach allows us to
            support businesses with precision, adaptability, and long-term hiring value.
          </p>

          <h3 className="services-subtitle">
            <span>
              Industries We Proudly Serve with Expert Workforce Solutions
            </span>
          </h3>
        </div>

        <div className="industries-list-container">
          {industries.map((industry, index) => (
            <div key={index} className="industry-item">
              <FontAwesomeIcon icon={industry.icon} className="industry-icon" />
              <span className="industry-name">{industry.name}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Services;